import { Spacing } from '@persona-id/design-tokens';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import ButtonComponentConfigAddOn from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentConfigSetting/ComponentConfigSettingAddOns/ButtonComponentConfigAddOn';
import InputCountrySelectComponentConfigAddOn from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentConfigSetting/ComponentConfigSettingAddOns/InputCountrySelectComponentConfigAddOn';
import { SectionAccordion } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/SectionAccordion';
import { InquiryTemplateVersionStepUi } from 'dashboard/models/inquiry-template-version';
import { UiComponentConfig, UiComponentConfigType } from 'lib/interfaces/ui-components';

const ComponentPanelSettingContainer = styled.div`
  display: flex;
  gap: ${Spacing[2]};
  flex-direction: column;
`;

interface ComponentConfigSettingAddOnsProps {
  componentConfig: UiComponentConfig;
  basePath: string;
  baseRoutePath: string;
  stepBasePath: string;
  editable: boolean;
  isNewComponent: boolean;
  currentStep: InquiryTemplateVersionStepUi;
}

// This component is responsible for rendering all the one-off
// settings that can't be generalized using server side editor configs
const ComponentConfigSettingAddOns = ({
  basePath,
  baseRoutePath,
  stepBasePath,
  componentConfig,
  editable,
  isNewComponent,
  currentStep,
  children,
}: PropsWithChildren<ComponentConfigSettingAddOnsProps>) => {
  let settingsContent = children;
  switch (componentConfig.type) {
    case UiComponentConfigType.ButtonAction:
    case UiComponentConfigType.ButtonCancel:
    case UiComponentConfigType.ButtonSubmit:
    case UiComponentConfigType.ButtonComplete:
      settingsContent = (
        <ButtonComponentConfigAddOn
          stepBasePath={stepBasePath}
          basePath={basePath}
          editable={editable}
          isNewComponent={isNewComponent}
          currentStep={currentStep}
        >
          {children}
        </ButtonComponentConfigAddOn>
      );
      break;
    case UiComponentConfigType.InputCountrySelect:
      settingsContent = (
        <InputCountrySelectComponentConfigAddOn
          editable={editable}
          fieldPath={`${baseRoutePath}/config/fields/${componentConfig.config.field}`}
        >
          {children}
        </InputCountrySelectComponentConfigAddOn>
      );
      break;
  }

  if (!React.Children.count(settingsContent)) return <></>;
  return (
    <SectionAccordion title='Settings'>
      <ComponentPanelSettingContainer>{settingsContent}</ComponentPanelSettingContainer>
    </SectionAccordion>
  );
};

export default ComponentConfigSettingAddOns;
